import React, {useEffect} from "react";
import { Card, Col, FormGroup, Input, Label, Row } from "reactstrap";
import HelpTooltip from "../help-tooltip";
const Regex = {
  number:/^[1-9]$/,
  text:/^[A-Z]{1,2}\s\d{4}\s([B-D]|[F-H]|[J-N]|[P-T]|[V-Z]){3}$/
}
export default function DynamicInputs({ inputs, setForm, form ,validation,setValidation}) {
  const valid = (type,value) =>{
    return Regex[type].test(value)?"success":"danger"
  }
  useEffect(()=>{
    if(form&&inputs){
      const tmpV = Object.fromEntries(inputs.map(o=>[o.name,""]))
      inputs.forEach(x=>{
        tmpV[x.name]=valid(x.type,form[x.name])
      })
      setValidation(tmpV);
    }
  },[form,inputs,setValidation])
  const onChangeInput = ({ target }) => {
    setForm({ [target.name]: target.value });
  };
  return (
    <>
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              DATOS DE ENTRADA PARA LA FUNCIÓN
            </h1>
          </Col>
          <Col xs="12">
            <Row>
              {inputs.map((o, key) => (
                <Col md={4} key={key}>
                  <FormGroup>
                    <Label>
                      {o.title} <HelpTooltip msg={o.tooltip} />
                    </Label>
                    <Input
                        invalid={validation?validation[o.name]==="danger":false}
                        valid={validation?validation[o.name]==="success":false}
                      type={o.type}
                      name={o.name}
                      onChange={onChangeInput}
                      value={form[o.name] || ""}
                    />
                  </FormGroup>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  );
}
